/*
 * @Author: 刘小博
 * @Date: 2023-02-17 14:16:48
 * @LastEditTime: 2023-02-17 14:32:04
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\abutment-module\abutment-manage\index.js
 * 对接管理
 */
import abutmentDisposeRouter from './modules/abutmentDisposeRouter'
import logRouter from './modules/logRouter'
import systemSettingsRouter from './modules/systemSettingsRouter'

const abutmentManageRouter = [].concat(
  abutmentDisposeRouter,
  logRouter,
  systemSettingsRouter,
)

export default abutmentManageRouter
